(function(){
	const serverRenderedErrorLists = Array.from(document.querySelectorAll('.module_object.error ul.ul'))
		.filter(function(list){ return list.children.length > 0; })
		.map(function(list){
			return {
				list: list,
				items: Array.from(list.children).map(function(item){ return item.cloneNode(true); }),
			};
		});

	document.addEventListener('DOMContentLoaded', function(){
		serverRenderedErrorLists.forEach(function(entry){
			if(entry.list.children.length > 0) return;
			entry.items.forEach(function(item){ entry.list.appendChild(item); });
		});
	});

	const registeredProductsState = {
		selectedProductId: '',
		removeRegistrationId: '',
		removeProductId: '',
		addPending: false,
		removePending: false,
		profilePending: false,
		showroomPending: false,
	};
	const pendingAccountTypeStorageKey = 'ariafina.pendingAccountType';
	const registrationRedirectStorageKey = 'ariafina.registrationRedirectPending';
	const productSuggestionsState = new WeakMap();
	let productSuggestionsSnapshot = null;
	const registeredExhibitProductIds = new Set((function(){
		const modalContents = document.querySelector('#modal_contents');
		const ids = modalContents ? modalContents.dataset.registeredExhibitProductIds || '' : '';
		return ids.split('|').filter(Boolean);
	})());

	function isRegisteredExhibitProduct(productId){
		return isShowroomExhibitMode() && registeredExhibitProductIds.has(productId);
	}

	function markRegisteredProductSuggestions(root){
		root.querySelectorAll('[data-product-id]').forEach(function(suggestion){
			if(!isRegisteredExhibitProduct(suggestion.dataset.productId || '')) return;

			suggestion.classList.add('is-registered');
			suggestion.setAttribute('aria-disabled', 'true');
			suggestion.setAttribute('tabindex', '-1');
			suggestion.removeAttribute('onclick');
			suggestion.style.cursor = 'not-allowed';
			suggestion.style.opacity = '0.4';

			if(!suggestion.querySelector('.registered_tag')){
				const tag = document.createElement('span');
				const label = document.createElement('span');
				tag.className = 'registered_tag font s_10 w_sb';
				label.textContent = '登録済み';
				tag.appendChild(label);
				suggestion.appendChild(tag);
			}
		});
	}

	function getProductSuggestionsState(input){
		let state = productSuggestionsState.get(input);
		if(!state){
			state = { timer: 0, controller: null, query: '' };
			productSuggestionsState.set(input, state);
		}
		return state;
	}

	async function fetchProductSuggestionsPage(input, suggestions, query, page, append, trigger){
		const state = getProductSuggestionsState(input);
		const controller = new AbortController();
		const endpoint = suggestions.dataset.productSuggestionsUrl || '/search';
		const url = new URL(endpoint, window.location.origin);
		const triggerLabel = trigger ? trigger.querySelector('.font > span') : null;
		const originalTriggerLabel = triggerLabel ? triggerLabel.textContent : '';

		state.controller = controller;
		suggestions.setAttribute('aria-busy', 'true');
		if(trigger){
			trigger.disabled = true;
			trigger.setAttribute('aria-busy', 'true');
			if(triggerLabel) triggerLabel.textContent = '読み込み中…';
		}

		url.searchParams.set('q', query);
		url.searchParams.set('type', 'product');
		url.searchParams.set('options[prefix]', 'last');
		url.searchParams.set('section_id', 'original-account-product-suggestions');
		if(page > 1) url.searchParams.set('page', String(page));

		try {
			const response = await fetch(url.toString(), {
				credentials: 'same-origin',
				signal: controller.signal,
			});
			const html = await response.text();
			if(!response.ok) throw new Error('Product suggestions request failed: ' + response.status);
			if(!input.isConnected || input.value.trim() !== query || state.query !== query) return;

			const responseDocument = new DOMParser().parseFromString(html, 'text/html');
			const results = responseDocument.querySelector('[data-product-suggestion-results]');
			if(!results) throw new Error('Product suggestions response markup was not found');
			if(append){
				const currentMoreItem = suggestions.querySelector('[data-product-suggestions-more-item]');
				if(currentMoreItem) currentMoreItem.remove();
				Array.from(results.children).forEach(function(child){ suggestions.appendChild(child); });
			} else {
				suggestions.innerHTML = results.innerHTML;
			}
			markRegisteredProductSuggestions(suggestions);
		} catch(error) {
			if(error.name !== 'AbortError'){
				console.error(error);
				if(!append) suggestions.replaceChildren();
			}
		} finally {
			if(trigger && trigger.isConnected){
				trigger.disabled = false;
				trigger.removeAttribute('aria-busy');
				if(triggerLabel) triggerLabel.textContent = originalTriggerLabel;
			}
			if(state.controller === controller){
				state.controller = null;
				suggestions.removeAttribute('aria-busy');
			}
		}
	}

	window.requestProductSuggestions = function(input){
		const modalContent = input.closest('#modal, #modal_contents') || document;
		const suggestions = modalContent.querySelector('ul.suggestions');
		const query = input.value.trim();
		const state = getProductSuggestionsState(input);

		if(!suggestions) return;

		window.clearTimeout(state.timer);
		if(state.controller) state.controller.abort();
		state.controller = null;
		state.query = query;
		suggestions.replaceChildren();
		suggestions.removeAttribute('aria-busy');

		if(!query) return;

		suggestions.setAttribute('aria-busy', 'true');
		state.timer = window.setTimeout(function(){
			state.timer = 0;
			fetchProductSuggestionsPage(input, suggestions, query, 1, false, null);
		}, 250);
	};

	window.loadMoreProductSuggestions = function(trigger){
		if(!trigger || trigger.disabled) return;

		const suggestions = trigger.closest('ul.suggestions');
		const modalContent = trigger.closest('#modal, #modal_contents') || document;
		const input = modalContent.querySelector('#add_product_1_search');
		const page = Number(trigger.dataset.nextPage || 0);
		if(!suggestions || !input || page < 2) return;

		const query = input.value.trim();
		const state = getProductSuggestionsState(input);
		if(!query || state.controller || state.query !== query) return;

		fetchProductSuggestionsPage(input, suggestions, query, page, true, trigger);
	};

	window.selectProductSuggestion = function(trigger){
		if(!trigger || trigger.getAttribute('aria-disabled') === 'true' || isRegisteredExhibitProduct(trigger.dataset.productId || '')) return;

		const modalContent = trigger.closest('#modal, #modal_contents') || document;
		const input = modalContent.querySelector('#add_product_1_search');
		const suggestions = trigger.closest('ul.suggestions');
		if(input && suggestions){
			productSuggestionsSnapshot = {
				query: input.value,
				resultsHtml: suggestions.innerHTML,
				scrollTop: suggestions.scrollTop,
			};
		}

		const product = {
			id: trigger.dataset.productId || '',
			title: trigger.dataset.productTitle || '',
			category: trigger.dataset.productCategory || '',
			type: trigger.dataset.productType || '',
			subtitle: trigger.dataset.productSubtitle || '',
			sku: trigger.dataset.productSku || '',
			image: trigger.dataset.productImage || '',
		};

		registeredProductsState.selectedProductId = product.id;

		document.querySelectorAll('#add_product_2, #add_product_3').forEach(function(template){
			updateSelectedProductCard(template, product);
		});

		window.openModal('add_product_2');
	};

	window.returnToProductSuggestions = function(){
		window.openModal('add_product_1');
		if(!productSuggestionsSnapshot) return;

		const root = activeModalContent();
		const input = root.querySelector('#add_product_1_search');
		const suggestions = root.querySelector('ul.suggestions');
		if(!input || !suggestions) return;

		input.value = productSuggestionsSnapshot.query;
		suggestions.innerHTML = productSuggestionsSnapshot.resultsHtml;
		suggestions.scrollTop = productSuggestionsSnapshot.scrollTop;
		getProductSuggestionsState(input).query = input.value.trim();
		markRegisteredProductSuggestions(suggestions);
	};

	function updateSelectedProductCard(root, product){
		const thumbnail = root.querySelector('[data-selected-product-thumbnail]');
		let figure = thumbnail && thumbnail.querySelector('[data-selected-product-figure]');
		const title = root.querySelector('[data-selected-product-title]');
		const subtitle = root.querySelector('[data-selected-product-subtitle]');
		const category = root.querySelector('[data-selected-product-category]');
		const categorySet = root.querySelector('.category_set');
		let type = root.querySelector('[data-selected-product-type]');
		const sku = root.querySelector('[data-selected-product-sku]');
		const productId = root.querySelector('[data-selected-product-id]');

		if(productId) productId.value = product.id || '';
		if(thumbnail){
			if(product.image){
				if(!figure){
					figure = document.createElement('figure');
					figure.dataset.selectedProductFigure = '';
					thumbnail.prepend(figure);
				}
				const image = document.createElement('img');
				image.dataset.selectedProductImage = '';
				image.src = product.image;
				image.alt = product.title || product.sku || '';
				image.loading = 'lazy';
				image.decoding = 'async';
				figure.replaceChildren(image);
			}else if(figure){
				figure.remove();
			}
		}
		if(title) title.textContent = product.title || product.sku || '';
		if(subtitle) subtitle.textContent = product.subtitle || '';
		if(category) category.textContent = product.category || '';
		if(product.type){
			if(!type && categorySet){
				const typeContainer = document.createElement('div');
				typeContainer.className = 'type font s_10 w_sb';
				type = document.createElement('span');
				type.dataset.selectedProductType = '';
				typeContainer.appendChild(type);
				categorySet.appendChild(typeContainer);
			}
			if(type) type.textContent = product.type;
		}else if(type){
			const typeContainer = type.closest('.type');
			if(typeContainer) typeContainer.remove();
		}
		if(sku) sku.textContent = product.sku || '';
	}

	function activeModalContent(){
		return document.querySelector('#modal > .dialog > .container') || document;
	}

	function activeModalTemplateId(){
		const modal = document.querySelector('#modal');
		return modal ? modal.dataset.content || '' : '';
	}

	function submittedForm(root, trigger){
		if(trigger){
			if(trigger.tagName === 'FORM') return trigger;
			const form = trigger.closest('form');
			if(form) return form;
		}
		return root.querySelector('form');
	}

	function passesOriginalValidation(form){
		return !form || typeof window.validateForm !== 'function' || window.validateForm(form);
	}

	function reportsShowroomValidity(form){
		if(!form || typeof form.reportValidity !== 'function') return true;

		const eitherOrControls = Array.from(form.querySelectorAll('[name$="_tel1"], [name$="_tel2"], [name$="_tel3"], [name$="_contact"]'));
		const requiredControls = eitherOrControls.filter(function(control){ return control.required; });
		requiredControls.forEach(function(control){ control.required = false; });

		try {
			return form.reportValidity();
		} finally {
			requiredControls.forEach(function(control){ control.required = true; });
		}
	}

	function validateRecoverCustomerPasswordForm(form){
		const email = form && form.querySelector('#RecoverEmail');
		if(!email) return true;

		const value = email.value.trim();
		const valid = value !== '' && (/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(value);
		if(valid){
			email.removeAttribute('aria-invalid');
			return true;
		}

		const message = value === ''
			? 'メールアドレスを入力してください'
			: '正しいメールアドレスを入力してください';
		const field = email.closest('.field');
		const errorBlock = form.querySelector('.module_object.error');
		const errorList = errorBlock && errorBlock.querySelector('ul.ul');

		if(field) field.classList.add('error');
		email.setAttribute('aria-invalid', 'true');
		if(errorList){
			errorList.innerHTML = '';
			const item = document.createElement('li');
			item.innerHTML = '<div class="font s_12 w_r"><span></span></div>';
			item.querySelector('span').textContent = message;
			errorList.appendChild(item);
		}
		if(errorBlock) errorBlock.classList.add('show');
		form.dataset.validated = '1';
		return false;
	}

	window.validateShopifyForm = function(form){
		if(form && form.querySelector('#RecoverEmail') && !validateRecoverCustomerPasswordForm(form)) return false;
		if(!form) return true;
		if(typeof window.validateForm !== 'function'){
			const valid = typeof form.checkValidity !== 'function' || form.checkValidity();
			if(!valid && typeof form.reportValidity === 'function') form.reportValidity();
			return valid;
		}

		const password = form.querySelector('[name="customer[password]"]');
		const confirmation = form.querySelector('[name="customer[password_confirmation]"]');
		if(!password || !confirmation) return window.validateForm(form);

		const passwordName = password.name;
		const confirmationName = confirmation.name;
		password.name = 'customer_password_1';
		confirmation.name = 'customer_password_2';

		try {
			return window.validateForm(form);
		} finally {
			password.name = passwordName;
			confirmation.name = confirmationName;
		}
	};

	// Customer forms must never rely solely on their inline onsubmit attributes.
	// Intercept them in the capture phase so invalid values cannot reach Shopify
	// even if another submit handler runs afterward.
	document.addEventListener('submit', function(event){
		const form = event.target;
		if(!(form instanceof HTMLFormElement)) return;

		if(form.id === 'create_customer'){
			if(window.validateShopifyForm(form)) return;
			event.preventDefault();
			return;
		}

		if(!form.querySelector('#RecoverEmail') || validateRecoverCustomerPasswordForm(form)) return;

		event.preventDefault();
	}, true);

	function selectedProductId(root){
		const input = root.querySelector('[data-selected-product-id]');
		return registeredProductsState.selectedProductId || (input ? input.value : '');
	}

	function isShowroomExhibitMode(){
		return document.body && document.body.dataset.account === 'partners';
	}

	function fieldValue(root, selector){
		const field = root.querySelector(selector);
		return field ? field.value.trim() : '';
	}

	function checked(root, selector){
		const field = root.querySelector(selector);
		return !!(field && field.checked);
	}

	function monthDate(year, month){
		if(!year || !month) return '';
		return String(year).padStart(4, '0') + '-' + String(month).padStart(2, '0') + '-01';
	}

	function showProductMessage(root, message){
		const container = root.querySelector('[data-product-form-message]');
		const text = container ? container.querySelector('span') : null;

		if(container && text){
			text.textContent = message;
			container.classList.remove('hidden');
			return;
		}

		window.alert(message);
	}

	function clearProductMessage(root){
		root.querySelectorAll('[data-product-form-message]').forEach(function(container){
			const text = container.querySelector('span');
			if(text) text.textContent = '';
			container.classList.add('hidden');
		});
	}

	function setProductButtonsPending(root, handlerName, pending){
		root.querySelectorAll('[onclick*="' + handlerName + '"]').forEach(function(button){
			button.classList.toggle('disabled', pending);
			button.setAttribute('aria-busy', pending ? 'true' : 'false');
		});
	}

	function appProxyUrl(path){
		const url = new URL(path, window.location.origin);
		const reservedParams = ['signature', 'timestamp', 'logged_in_customer_id', 'shop', 'path_prefix'];

		new URLSearchParams(window.location.search).forEach(function(value, key){
			if(reservedParams.includes(key) || url.searchParams.has(key)) return;
			url.searchParams.append(key, value);
		});

		return url.pathname + url.search;
	}

	async function postRegisteredProduct(path, payload){
		const response = await fetch(appProxyUrl(path), {
			method: 'POST',
			headers: { 'content-type': 'application/json' },
			credentials: 'same-origin',
			body: JSON.stringify(payload),
		});

		let data = null;
		let responseText = '';
		try {
			responseText = await response.text();
			data = responseText ? JSON.parse(responseText) : null;
		} catch(e) {
			data = null;
		}

		if(response.redirected && response.url.indexOf('/password') !== -1){
			throw new Error('アプリ連携がストアのパスワードページにリダイレクトされました。ストアフロントのパスワード認証後に再度お試しください。');
		}

		if(!response.ok){
			let message = data && data.error ? data.error : '';
			if(!message){
				message = 'アプリ連携に失敗しました。HTTP ' + response.status + ' の応答を受信しました。';
			}
			throw new Error(message);
		}

		if(!data){
			throw new Error('アプリ連携から正しい応答を受信できませんでした。ページを再読み込みして再度お試しください。');
		}

		return data;
	}

	function showProfileMessage(root, message){
		const container = root.querySelector('[data-profile-form-message]');
		const text = container ? container.querySelector('span') : null;

		if(container && text){
			text.textContent = message;
			container.classList.remove('hidden');
			return;
		}

		window.alert(message);
	}

	function clearProfileMessage(root){
		root.querySelectorAll('[data-profile-form-message]').forEach(function(container){
			const text = container.querySelector('span');
			if(text) text.textContent = '';
			container.classList.add('hidden');
		});
	}

	function setProfileButtonsPending(root, pending){
		root.querySelectorAll('[onclick*="saveProfile"]').forEach(function(button){
			button.classList.toggle('disabled', pending);
			button.setAttribute('aria-busy', pending ? 'true' : 'false');
		});
	}

	function profilePayload(root){
		return {
			lastName: fieldValue(root, '#edit_profile_last_name'),
			firstName: fieldValue(root, '#edit_profile_first_name'),
			email: fieldValue(root, '#edit_profile_email'),
		};
	}

	window.saveProfile = async function(trigger){
		if(registeredProductsState.profilePending) return;

		const root = activeModalContent();
		const form = submittedForm(root, trigger);
		const payload = profilePayload(root);

		clearProfileMessage(root);

		if(!passesOriginalValidation(form)) return;

		if(form && typeof form.reportValidity === 'function' && !form.reportValidity()){
			return;
		}

		if(!payload.lastName || !payload.firstName || !payload.email){
			showProfileMessage(root, '姓、名、メールアドレスを入力してください。');
			return;
		}

		registeredProductsState.profilePending = true;
		setProfileButtonsPending(root, true);
		showProfileMessage(root, '保存しています。しばらくお待ちください。');

		try {
			await postRegisteredProduct('/apps/registered-products/profile/update', payload);
			showProfileMessage(root, '保存しました。表示を更新しています。');
			window.location.reload();
		} catch(error) {
			showProfileMessage(root, error.message);
		} finally {
			registeredProductsState.profilePending = false;
			setProfileButtonsPending(root, false);
		}
	};

	function showShowroomMessage(root, message){
		const container = root.querySelector('[data-showroom-form-message]');
		const text = container ? container.querySelector('span') : null;

		if(container && text){
			text.textContent = message;
			container.classList.remove('hidden');
			return;
		}

		window.alert(message);
	}

	function clearShowroomMessage(root){
		root.querySelectorAll('[data-showroom-form-message]').forEach(function(container){
			const text = container.querySelector('span');
			if(text) text.textContent = '';
			container.classList.add('hidden');
		});
	}

	function setShowroomButtonsPending(root, pending){
		root.querySelectorAll('[onclick*="saveShowroomInfo"], [onclick*="removeShowroomInfo"]').forEach(function(button){
			button.classList.toggle('disabled', pending);
			button.setAttribute('aria-busy', pending ? 'true' : 'false');
		});
	}

	function showroomPayload(root){
		const prefix = activeModalTemplateId() === 'add_showroom_info_4'
			? '#add_showroom_info_4_'
			: '#edit_showroom_info_';

		return {
			name: fieldValue(root, prefix + 'showroom_name') || fieldValue(root, prefix + 'shwroom_name'),
			postalCode: fieldValue(root, prefix + 'zip'),
			province: fieldValue(root, prefix + 'province'),
			city: fieldValue(root, prefix + 'city'),
			address1: fieldValue(root, prefix + 'address1'),
			address2: fieldValue(root, prefix + 'address2'),
			mapUrl: fieldValue(root, prefix + 'googlemaps'),
			phone1: fieldValue(root, prefix + 'tel1'),
			phone2: fieldValue(root, prefix + 'tel2'),
			phone3: fieldValue(root, prefix + 'tel3'),
			closedDays: fieldValue(root, prefix + 'closed_days'),
			websiteUrl: fieldValue(root, prefix + 'website'),
			contact: fieldValue(root, prefix + 'contact'),
		};
	}

	window.saveShowroomInfo = async function(trigger){
		if(registeredProductsState.showroomPending) return;

		const root = activeModalContent();
		const form = submittedForm(root, trigger);
		const payload = showroomPayload(root);

		clearShowroomMessage(root);

		if(!passesOriginalValidation(form)) return;
		if(!reportsShowroomValidity(form)) return;

		if(!payload.name || !payload.postalCode || !payload.province || !payload.city || !payload.address1 || !payload.mapUrl){
			showShowroomMessage(root, '必須項目を入力してください。');
			return;
		}

		const phoneParts = [payload.phone1, payload.phone2, payload.phone3];
		const hasAnyPhonePart = phoneParts.some(function(part){ return !!part; });
		if(!hasAnyPhonePart && !payload.contact){
			showShowroomMessage(root, '電話番号かお問い合わせ先URL / メールアドレスのいずれかを入力してください。');
			return;
		}

		if(hasAnyPhonePart){
			if(!phoneParts.every(function(part){ return !!part; })){
				showShowroomMessage(root, '電話番号を正しく入力してください。');
				return;
			}

			if(!phoneParts.every(function(part){ return /^[0-9]+$/.test(part); })){
				showShowroomMessage(root, '電話番号は半角数字で入力してください。');
				return;
			}

			const phoneLength = phoneParts.join('').length;
			if(phoneLength !== 10 && phoneLength !== 11){
				showShowroomMessage(root, '電話番号は10桁または11桁で入力してください。');
				return;
			}
		}

		registeredProductsState.showroomPending = true;
		setShowroomButtonsPending(root, true);
		showShowroomMessage(root, '保存しています。しばらくお待ちください。');

		try {
			await postRegisteredProduct('/apps/registered-products/showroom/update', payload);
			showShowroomMessage(root, '保存しました。表示を更新しています。');
			window.location.reload();
		} catch(error) {
			showShowroomMessage(root, error.message);
		} finally {
			registeredProductsState.showroomPending = false;
			setShowroomButtonsPending(root, false);
		}
	};

	window.removeShowroomInfo = async function(trigger){
		if(trigger && trigger.classList.contains('disabled')) return;
		if(registeredProductsState.showroomPending) return;

		const root = activeModalContent();

		clearShowroomMessage(root);

		if(!checked(root, 'input[name="remove_showroom_info_notice_confirmed"]')){
			showShowroomMessage(root, '注意事項の確認にチェックを入れてください。');
			return;
		}

		registeredProductsState.showroomPending = true;
		setShowroomButtonsPending(root, true);
		showShowroomMessage(root, '削除しています。しばらくお待ちください。');

		try {
			await postRegisteredProduct('/apps/registered-products/showroom/delete', {});
			showShowroomMessage(root, '削除しました。表示を更新しています。');
			window.location.reload();
		} catch(error) {
			showShowroomMessage(root, error.message);
		} finally {
			registeredProductsState.showroomPending = false;
			setShowroomButtonsPending(root, false);
		}
	};

	window.addProduct = async function(trigger){
		if(registeredProductsState.addPending) return;

		const root = activeModalContent();
		const form = submittedForm(root, trigger);
		const productId = selectedProductId(root);

		clearProductMessage(root);

		if(!passesOriginalValidation(form)) return;

		if(!productId){
			showProductMessage(root, '追加する製品を選択してください。');
			return;
		}

		if(isRegisteredExhibitProduct(productId)){
			showProductMessage(root, 'この製品は登録済みです。');
			return;
		}

		const payload = { productId: productId };

		if(activeModalTemplateId() === 'add_product_3'){
			const startedOn = monthDate(
				fieldValue(root, '#add_product_3_from_year'),
				fieldValue(root, '#add_product_3_from_month'),
			);
			const endedOn = monthDate(
				fieldValue(root, '#add_product_3_to_year'),
				fieldValue(root, '#add_product_3_to_month'),
			);
			const purchasedFrom = fieldValue(root, '#add_product_3_purchased_from');
			const serialNumber = fieldValue(root, '#add_product_3_serial_number');

			if(startedOn) payload.startedOn = startedOn;
			if(!checked(root, 'input[name="using"]') && endedOn) payload.endedOn = endedOn;
			if(purchasedFrom) payload.purchasedFrom = purchasedFrom;
			if(serialNumber) payload.serialNumber = serialNumber;
		}

		registeredProductsState.addPending = true;
		setProductButtonsPending(root, 'addProduct', true);
		showProductMessage(root, '登録しています。しばらくお待ちください。');

		try {
			const endpoint = isShowroomExhibitMode()
				? '/apps/registered-products/exhibits/add'
				: '/apps/registered-products/add';
			await postRegisteredProduct(endpoint, payload);
			showProductMessage(root, '登録しました。表示を更新しています。');
			window.location.reload();
		} catch(error) {
			showProductMessage(root, error.message);
		} finally {
			registeredProductsState.addPending = false;
			setProductButtonsPending(root, 'addProduct', false);
		}
	};

	window.openRemoveProductModal = function(trigger){
		registeredProductsState.removeRegistrationId = trigger ? trigger.dataset.registrationId || '' : '';
		window.openModal('remove_product');
	};

	window.openRemoveExhibitProductModal = function(trigger){
		registeredProductsState.removeProductId = trigger ? trigger.dataset.productId || '' : '';
		window.openModal('remove_product');
	};

	window.removeProduct = async function(){
		if(registeredProductsState.removePending) return;

		const root = activeModalContent();
		const isExhibit = isShowroomExhibitMode();
		const removeId = isExhibit ? registeredProductsState.removeProductId : registeredProductsState.removeRegistrationId;

		clearProductMessage(root);

		if(!removeId){
			showProductMessage(root, '削除対象の製品を取得できませんでした。ページを再読み込みして再度お試しください。');
			return;
		}

		registeredProductsState.removePending = true;
		setProductButtonsPending(root, 'removeProduct', true);
		showProductMessage(root, '削除しています。しばらくお待ちください。');

		try {
			const endpoint = isExhibit
				? '/apps/registered-products/exhibits/remove'
				: '/apps/registered-products/remove';
			const payload = isExhibit ? { productId: removeId } : { registrationId: removeId };
			await postRegisteredProduct(endpoint, payload);
			showProductMessage(root, '削除しました。表示を更新しています。');
			window.location.reload();
		} catch(error) {
			showProductMessage(root, error.message);
		} finally {
			registeredProductsState.removePending = false;
			setProductButtonsPending(root, 'removeProduct', false);
		}
	};

	window.deleteCustomerAddress = function(url, redirectUrl){
		/* Shopifyの住所削除POSTはreturn_toを無視して/account/addressesへ
		   リダイレクトするため、fetchで削除してからマイページへ戻す。 */
		const fallbackUrl = redirectUrl || '/account';

		fetch(url, {
			method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			credentials: 'same-origin',
			body: '_method=delete',
		}).then(function(){
			window.location.href = fallbackUrl;
		}).catch(function(){
			window.location.href = fallbackUrl;
		});
	};

	if(typeof window.openModal !== 'function') return;

	const originalOpenModal = window.openModal;

	function idSelector(id){
		if(window.CSS && typeof window.CSS.escape === 'function') return '#' + window.CSS.escape(id);
		return '#' + id.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
	}

	function initOriginalAddressCountrySelectors(root){
		const japanPrefectures = [
			['北海道', 'hokkaido'], ['青森県', 'aomori'], ['岩手県', 'iwate'], ['宮城県', 'miyagi'],
			['秋田県', 'akita'], ['山形県', 'yamagata'], ['福島県', 'fukushima'], ['茨城県', 'ibaraki'],
			['栃木県', 'tochigi'], ['群馬県', 'gunma'], ['埼玉県', 'saitama'], ['千葉県', 'chiba'],
			['東京都', 'tokyo'], ['神奈川県', 'kanagawa'], ['新潟県', 'niigata'], ['富山県', 'toyama'],
			['石川県', 'ishikawa'], ['福井県', 'fukui'], ['山梨県', 'yamanashi'], ['長野県', 'nagano'],
			['岐阜県', 'gifu'], ['静岡県', 'shizuoka'], ['愛知県', 'aichi'], ['三重県', 'mie'],
			['滋賀県', 'shiga'], ['京都府', 'kyoto'], ['大阪府', 'osaka'], ['兵庫県', 'hyogo'],
			['奈良県', 'nara'], ['和歌山県', 'wakayama'], ['鳥取県', 'tottori'], ['島根県', 'shimane'],
			['岡山県', 'okayama'], ['広島県', 'hiroshima'], ['山口県', 'yamaguchi'], ['徳島県', 'tokushima'],
			['香川県', 'kagawa'], ['愛媛県', 'ehime'], ['高知県', 'kochi'], ['福岡県', 'fukuoka'],
			['佐賀県', 'saga'], ['長崎県', 'nagasaki'], ['熊本県', 'kumamoto'], ['大分県', 'oita'],
			['宮崎県', 'miyazaki'], ['鹿児島県', 'kagoshima'], ['沖縄県', 'okinawa']
		];
		const japanPrefectureOrder = new Map();
		japanPrefectures.forEach(function(names, index){
			names.forEach(function(name){ japanPrefectureOrder.set(name.toLowerCase(), index); });
		});

		function isJapanOption(option){
			if(!option) return false;
			const country = (option.value + ' ' + option.textContent).trim().toLowerCase();
			return country === 'jp' || country.indexOf('japan') !== -1 || country.indexOf('日本') !== -1;
		}

		function japanesePrefectureIndex(province, originalIndex){
			const codeMatch = String(province[0] || '').match(/(?:jp[-_])?(\d{2})$/i);
			if(codeMatch){
				const codeIndex = Number(codeMatch[1]) - 1;
				if(codeIndex >= 0 && codeIndex < 47) return codeIndex;
			}

			const candidates = [province[0], province[1]].map(function(value){
				return String(value || '').trim().toLowerCase().replace(/\s+prefecture$/, '');
			});
			for(const candidate of candidates){
				if(japanPrefectureOrder.has(candidate)) return japanPrefectureOrder.get(candidate);
			}
			return 1000 + originalIndex;
		}

		root.querySelectorAll('[data-original-address-country-select]').forEach(function(countrySelect){
			const provinceSelectId = countrySelect.dataset.provinceSelectId;
			const provinceContainerId = countrySelect.dataset.provinceContainerId || provinceSelectId;

			if(!countrySelect.id || !provinceSelectId || countrySelect.dataset.addressCountryInitialized === 'true') return;

			const provinceSelect = root.querySelector(idSelector(provinceSelectId));
			if(!provinceSelect) return;

			const defaultCountry = countrySelect.dataset.default;
			if(defaultCountry){
				Array.from(countrySelect.options).some(function(option){
					const isDefault = option.value === defaultCountry || option.text === defaultCountry;
					if(isDefault) option.selected = true;
					return isDefault;
				});
			}

			function updateProvinceOptions(){
				const selectedOption = countrySelect.options[countrySelect.selectedIndex];
				const rawProvinces = selectedOption ? selectedOption.getAttribute('data-provinces') : null;
				const provinceContainer = root.querySelector(idSelector(provinceContainerId));
				const defaultProvince = provinceSelect.dataset.default;
				let provinces = [];

				try {
					provinces = rawProvinces ? JSON.parse(rawProvinces) : [];
				} catch(e) {
					provinces = [];
				}

				if(isJapanOption(selectedOption)){
					provinces = provinces.map(function(province, index){
						return { province: province, order: japanesePrefectureIndex(province, index) };
					}).sort(function(a, b){
						return a.order - b.order;
					}).map(function(entry){
						return entry.province;
					});
				}

				provinceSelect.replaceChildren();

				if(!provinces.length){
					if(provinceContainer) provinceContainer.style.display = 'none';
					return;
				}

				if(provinceContainer) provinceContainer.style.display = '';

				provinces.forEach(function(province){
					const option = document.createElement('option');
					option.value = province[0];
					option.textContent = province[1];
					if(defaultProvince && (province[0] === defaultProvince || province[1] === defaultProvince)){
						option.selected = true;
					}
					provinceSelect.appendChild(option);
				});
			}

			countrySelect.dataset.addressCountryInitialized = 'true';
			countrySelect.addEventListener('change', updateProvinceOptions);
			updateProvinceOptions();
		});
	}

	window.openModal = function(_id, _trigger){
		if(_trigger && _trigger.classList.contains('disabled')) return;

		const modal = document.querySelector('#modal');
		const dialog = document.querySelector('#modal > .dialog');
		const container = document.querySelector('#modal > .dialog > .container');
		const content = document.getElementById(_id);

		if(!modal || !dialog || !container || !content){
			console.warn('Modal content not found: ' + _id);
			return;
		}

		originalOpenModal(_id, _trigger);
		initOriginalAddressCountrySelectors(container);
	};

	function openModalWithFormErrors(){
		const content = document.querySelector('[data-original-modal-auto-open]');
		const modalId = content ? content.dataset.originalModalAutoOpen : '';
		if(modalId) window.openModal(modalId);
	}

	function initOriginalHome(){
		if(document.body.dataset.page !== 'home') return;
		document.body.classList.add('original-home-ready');

		const header = document.querySelector('#wrapper header');
		const teaserHeading = document.querySelector('#teaser > h1');
		const aboutHeading = document.querySelector('#about > h2');

		function updateHomeLayout(){
			const headerHeight = header ? header.offsetHeight : 0;
			document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
			document.documentElement.style.setProperty('--visible-height', (window.innerHeight - headerHeight) + 'px');
			document.documentElement.style.setProperty('--teaser-h1-height', (teaserHeading ? teaserHeading.offsetHeight : 0) + 'px');
			if(aboutHeading) aboutHeading.classList.toggle('hide', window.scrollY > 0);
		}

		const fades = Array.from(document.querySelectorAll('.original-home-section .fade'));
		if('IntersectionObserver' in window){
			const observer = new IntersectionObserver(function(entries){
				entries.filter(function(entry){ return entry.isIntersecting; }).forEach(function(entry, index){
					const delay = parseInt(entry.target.dataset.delay, 10) || 0;
					window.setTimeout(function(){ entry.target.classList.add('is-active'); }, delay + (index * 500));
					observer.unobserve(entry.target);
				});
			}, { threshold: 0.5 });
			fades.forEach(function(fade){ observer.observe(fade); });
		}else{
			fades.forEach(function(fade){ fade.classList.add('is-active'); });
		}

		updateHomeLayout();
		window.addEventListener('resize', updateHomeLayout, { passive: true });
		window.addEventListener('orientationchange', updateHomeLayout, { passive: true });
		window.addEventListener('scroll', updateHomeLayout, { passive: true });
	}

	function readPendingAccountType(){
		try {
			const accountType = window.sessionStorage.getItem(pendingAccountTypeStorageKey);
			return accountType === 'owner' || accountType === 'customer' ? accountType : '';
		} catch(error) {
			return '';
		}
	}

	function storePendingAccountType(accountType){
		try {
			window.sessionStorage.setItem(pendingAccountTypeStorageKey, accountType);
		} catch(error) {
			console.error('アカウント種別を一時保存できませんでした。', error);
		}
	}

	function clearPendingAccountType(){
		try {
			window.sessionStorage.removeItem(pendingAccountTypeStorageKey);
		} catch(error) {
			console.error('アカウント種別の一時保存を削除できませんでした。', error);
		}
	}

	function hasPendingRegistrationRedirect(){
		try {
			return window.sessionStorage.getItem(registrationRedirectStorageKey) === '1';
		} catch(error) {
			return false;
		}
	}

	function storePendingRegistrationRedirect(){
		try {
			window.sessionStorage.setItem(registrationRedirectStorageKey, '1');
		} catch(error) {
			console.error('アカウント作成後の遷移情報を一時保存できませんでした。', error);
		}
	}

	function clearPendingRegistrationRedirect(){
		try {
			window.sessionStorage.removeItem(registrationRedirectStorageKey);
		} catch(error) {
			console.error('アカウント作成後の遷移情報を削除できませんでした。', error);
		}
	}

	function initAccountTypeRegistration(){
		const registrationForm = document.querySelector('form#create_customer');
		if(registrationForm){
			const validationTrigger = registrationForm.querySelector('[data-registration-validation-trigger]');
			const nativeSubmit = registrationForm.querySelector('[data-registration-native-submit]');
			if(validationTrigger && nativeSubmit){
				nativeSubmit.hidden = true;
				validationTrigger.hidden = false;
				validationTrigger.addEventListener('click', function(){
					if(!window.validateShopifyForm(registrationForm)) return;

					if(typeof registrationForm.requestSubmit === 'function'){
						registrationForm.requestSubmit(nativeSubmit);
					}else{
						nativeSubmit.click();
					}
				});
				registrationForm.addEventListener('keydown', function(event){
					if(event.key !== 'Enter' || event.target.matches('textarea, button')) return;
					event.preventDefault();
					validationTrigger.click();
				});
			}

			// Shopify may apply return_to even when create_customer fails. The form no
			// longer sends return_to, so a server error stays on the registration form.
			if(registrationForm.querySelector('.module_object.error[autofocus]')){
				clearPendingAccountType();
				clearPendingRegistrationRedirect();
			}

			registrationForm.addEventListener('submit', function(event){
				if(event.defaultPrevented) return;
				const selected = registrationForm.querySelector('input[name="ariafina_account_type"]:checked');
				if(selected && (selected.value === 'owner' || selected.value === 'customer')){
					storePendingAccountType(selected.value);
					storePendingRegistrationRedirect();
				}
			});
		}

		const accountType = readPendingAccountType();
		const completeSection = document.querySelector('#register_complete');
		const isLoggedIn = document.body.getAttribute('login') === 'true';
		if(hasPendingRegistrationRedirect() && isLoggedIn && !completeSection){
			window.location.replace('/pages/register-complete');
			return;
		}

		if(completeSection && accountType){
			const accountLabel = accountType === 'owner' ? 'ARIAFINA Owners' : 'ARIAFINA Partners';
			completeSection.dataset.accountType = accountType;
			completeSection.querySelectorAll('[data-account-label]').forEach(function(label){
				label.textContent = accountLabel;
			});
		}
		if(!completeSection || !accountType || !isLoggedIn) return;

		if(completeSection) completeSection.setAttribute('aria-busy', 'true');

		postRegisteredProduct('/apps/registered-products/account-type/update', {
			accountType: accountType,
		}).then(function(){
			clearPendingAccountType();
			clearPendingRegistrationRedirect();
		}).catch(function(error){
			console.error('アカウント種別を更新できませんでした。', error);
			const errorContainer = document.querySelector('[data-account-type-sync-error]');
			if(errorContainer){
				const errorList = errorContainer.querySelector('[data-account-type-sync-error-list]');
				const errorTemplate = errorContainer.querySelector('[data-account-type-sync-error-template]');
				if(errorList && errorTemplate && !errorList.children.length){
					errorList.appendChild(errorTemplate.content.cloneNode(true));
				}
				const errorMessage = errorContainer.querySelector('[data-account-type-sync-error-message]');
				if(errorMessage) errorMessage.textContent = error.message;
				errorContainer.hidden = false;
			}
		}).finally(function(){
			if(completeSection) completeSection.removeAttribute('aria-busy');
		});
	}

	if(document.readyState === 'loading'){
		document.addEventListener('DOMContentLoaded', function(){
			openModalWithFormErrors();
			initOriginalHome();
			initAccountTypeRegistration();
		});
	}else{
		openModalWithFormErrors();
		initOriginalHome();
		initAccountTypeRegistration();
	}
})();

/* Password page: reveal the storefront password form from the discreet corner trigger. */
(function(){
	function initMaintenancePasswordAccess(){
		const access = document.querySelector('[data-maintenance-password-access]');
		if(!access || access.dataset.initialized === 'true') return;

		const trigger = access.querySelector('[data-maintenance-password-trigger]');
		const panel = access.querySelector('[data-maintenance-password-panel]');
		const input = panel ? panel.querySelector('input[name="password"]') : null;
		if(!trigger || !panel) return;

		access.dataset.initialized = 'true';

		function setOpen(open){
			panel.hidden = !open;
			access.classList.toggle('is-open', open);
			trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
			if(open && input) input.focus();
		}

		trigger.addEventListener('click', function(){
			setOpen(panel.hidden);
		});

		document.addEventListener('keydown', function(event){
			if(event.key !== 'Escape' || panel.hidden) return;
			setOpen(false);
			trigger.focus();
		});
	}

	if(document.readyState === 'loading'){
		document.addEventListener('DOMContentLoaded', initMaintenancePasswordAccess);
	}else{
		initMaintenancePasswordAccess();
	}
})();

/* Reservation list progressive disclosure. All rows remain visible without JavaScript. */
(function(){
	const defaultReservationBatchSize = 20;

	function initReservationLists(){
		document.querySelectorAll('[data-reservation-list]').forEach(function(list){
			const container = list.closest('.container');
			if(!container || container.dataset.reservationListInitialized === 'true') return;

			const batchSize = Math.max(1, parseInt(list.dataset.reservationBatchSize, 10) || defaultReservationBatchSize);
			const overflowRows = Array.from(list.querySelectorAll('[data-reservation-overflow]'));
			const button = container.querySelector('[data-reservation-load-more]');
			const buttonContainer = button ? button.closest('[data-reservation-load-more-container]') : null;
			if(!button || !buttonContainer) return;

			container.dataset.reservationListInitialized = 'true';
			container.classList.add('is-reservation-list-initialized');

			function setRowVisibility(row, visible){
				row.hidden = !visible;
				if(visible){
					row.style.removeProperty('display');
				}else{
					row.style.setProperty('display', 'none', 'important');
				}
			}

			function hideLoadMoreButton(){
				buttonContainer.hidden = true;
				buttonContainer.style.setProperty('display', 'none', 'important');
			}

			if(!overflowRows.length){
				hideLoadMoreButton();
				return;
			}

			overflowRows.forEach(function(row){
				setRowVisibility(row, false);
			});

			button.addEventListener('click', function(){
				overflowRows.splice(0, batchSize).forEach(function(row){
					row.removeAttribute('data-reservation-overflow');
					setRowVisibility(row, true);
				});
				if(!overflowRows.length) hideLoadMoreButton();
			});
		});
	}

	if(document.readyState === 'loading'){
		document.addEventListener('DOMContentLoaded', initReservationLists);
	}else{
		initReservationLists();
	}
})();

/* Teaser mode: clear an in-progress reservation/cart before logging out. */
(function(){
	document.addEventListener('click', function(event){
		const logoutLink = event.target.closest('[data-clear-cart-on-logout]');
		if(!logoutLink) return;

		event.preventDefault();
		if(logoutLink.dataset.clearCartPending === 'true') return;

		logoutLink.dataset.clearCartPending = 'true';
		logoutLink.setAttribute('aria-busy', 'true');
		logoutLink.setAttribute('aria-disabled', 'true');

		fetch('/cart/clear.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				Accept: 'application/json'
			}
		})
			.then(function(response){
				if(!response.ok) throw new Error('cart clear failed');
				window.location.assign(logoutLink.href);
			})
			.catch(function(){
				delete logoutLink.dataset.clearCartPending;
				logoutLink.removeAttribute('aria-busy');
				logoutLink.removeAttribute('aria-disabled');
				window.alert('カートの商品を削除できませんでした。ページを再読み込みして再度お試しください。');
			});
	});
})();

/* Product detail: keep Dawn add-to-cart submit visible/operable against app or shared CSS conflicts.
   Cowlendar hides the native ATC (`display:none !important`) and injects `.cowlendar-btn`
   ("エリアを変更する"). Do not undo that hide — reservation flow owns those products. */
(function(){
	function revealProductSubmitButtons(){
		if(!document.body.classList.contains('template-product')) return;

		document.querySelectorAll('.product-form__submit').forEach(function(button){
			if(button.classList.contains('cowlendar-btn')) return;
			if(typeof button.className === 'string' && button.className.indexOf('cowlendar-add-to-cart') !== -1) return;
			if(button.style.display === 'none' && button.style.getPropertyPriority('display') === 'important') return;
			if(button.closest('.product-form__buttons') && button.closest('.product-form__buttons').querySelector('.cowlendar-btn')) return;

			button.hidden = false;
			button.removeAttribute('hidden');
			if(button.getAttribute('aria-hidden') === 'true'){
				button.removeAttribute('aria-hidden');
			}
			if(button.style.display === 'none'){
				button.style.removeProperty('display');
			}
			if(button.style.visibility === 'hidden'){
				button.style.removeProperty('visibility');
			}
		});
	}

	if(document.readyState === 'loading'){
		document.addEventListener('DOMContentLoaded', revealProductSubmitButtons);
	}else{
		revealProductSubmitButtons();
	}

	document.addEventListener('shopify:section:load', revealProductSubmitButtons);
})();

/* System pages: initialize the photographed PC / mobile background without replacing shared assets. */
(function(){
	function initSystemBackgrounds(){
		if(document.body.dataset.page !== 'system') return;
		const mq = window.matchMedia('(max-width: 980px)');
		document.querySelectorAll('[data-system-background] > video').forEach(function(video){
			if(video.dataset.systemVideoInitialized === 'true') return;
			video.dataset.systemVideoInitialized = 'true';
			const canWebm = !!video.canPlayType('video/webm; codecs="vp9, vp8"') || !!video.canPlayType('video/webm');
			function apply(){
				if(!video.isConnected) return;
				const webm = mq.matches ? video.dataset.srcSpWebm : video.dataset.srcPcWebm;
				const mp4 = mq.matches ? video.dataset.srcSp : video.dataset.srcPc;
				const src = (canWebm && webm) ? webm : mp4;
				video.poster = mq.matches ? video.dataset.posterSp : video.dataset.posterPc;
				if(src && video.getAttribute('src') !== src){
					video.src = src;
					video.load();
				}
				video.parentElement.classList.add('is-active');
			}
			apply();
			mq.addEventListener('change', apply);
		});
	}
	if(document.readyState === 'loading'){
		document.addEventListener('DOMContentLoaded', initSystemBackgrounds);
	}else{
		initSystemBackgrounds();
	}
	document.addEventListener('shopify:section:load', initSystemBackgrounds);
})();
